import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild
} from '@angular/core';
import {StoryCard} from "./story-card";
import {OverlayService} from "../../overlay/overlay.service";
import {StoryCardLayout} from "./story-card-layout";
import {Story} from "../../interfaces/story";

@Component({
  selector: 'brt-card',
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class CardComponent implements AfterViewInit {

  StoryCardLayout = StoryCardLayout;
  @ViewChild("mainEl") mainEl! : ElementRef;
  cardData!: StoryCard;
  storyData!: Story;

  @Output('cardTimeout') cardTimeout = new EventEmitter<void>();

  @Input('current') current = false;
  @Input('isPreview') isPreview = false;
  @Input('label') label = "";

  @HostListener("window:resize", ['$event'])
  onResize($event: Event) {
    this.setCSSWidthVariable();
  }

  @Input('card-data') set setCardData(value: StoryCard) {
    if (typeof value !== 'undefined') {
      this.cardData = value;
    }
  }

  @Input('story-data') set setStoryData(value: Story) {
    if (typeof value !== 'undefined') {
      this.storyData = value;
    }
  }

  constructor(private overlayService: OverlayService) {
  }

  ngAfterViewInit() {
    setTimeout(() => {

      window.requestAnimationFrame(() => {
        this.setCSSWidthVariable();
      });
    }, 200);
  }

  setCSSWidthVariable() {
    const htmlEl = this.mainEl.nativeElement as HTMLElement;
    htmlEl.style.setProperty("--variable-width", htmlEl.clientWidth + "px");
  }


}
